import axios from 'axios'
import { getTenantSlug } from './tenant'

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
})


api.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    const slug = getTenantSlug()
    if (slug) config.headers['x-tenant'] = slug

    return config
})

export default api
